module.exports = __webpack_public_path__ + "img/ug414.d5d1fddc.png";